import { useEffect, useState } from "react";
import useUtils from "@/hooks/useUtils";
import { DESKTOP } from "@/utils/appConstants";

const useReadingProgress = (targetRef) => {
  const { device } = useUtils();
  const [completed, setCompleted] = useState(0);
  const [isSticky, setIsSticky] = useState(false);
  const desktop = device === DESKTOP;

  useEffect(() => {
    if (!targetRef?.current) return;

    let ticking = false;

    const updateScrollCompleted = () => {
      ticking = false;

      const scrollHeight = document.documentElement.scrollHeight - window.innerHeight;

      // Update progress percentage
      if (scrollHeight > 0) {
        setCompleted((window.scrollY / scrollHeight) * 100);
      }

      // Update sticky state
      if (targetRef.current) {
        const targetBottom = targetRef.current.getBoundingClientRect().bottom;
        setIsSticky(targetBottom <= 80);
      }
    };

    const onScroll = () => {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(updateScrollCompleted);
      }
    };

    window.addEventListener("scroll", onScroll, { passive: true });

    updateScrollCompleted();

    return () => {
      window.removeEventListener("scroll", onScroll);
    };
  }, [targetRef]);

  const getProgressBarClasses = () => {
    return isSticky ? "fixed top-20" : "absolute bottom-0";
  };

  return { completed, isSticky, getProgressBarClasses };
};

export default useReadingProgress;
